import React from 'react';
import PropTypes from 'prop-types';
import { GridContainer, GridItem } from './Dashboard.styles';

const UserGrid = ({ userName = 'Kendall Jenner', purchasedCourses = [] }) => {
  return (
    <GridContainer>
      <h1>Welcome, {userName}</h1>
      <GridItem href="/settings">Settings</GridItem>
      <GridItem href="/buy-courses">Buy Courses</GridItem>
      <GridItem href="/purchase-history">Purchase History</GridItem>
      <GridItem href="/logout">Logout</GridItem>
      <div className="courses">
        <h2>Your Courses</h2>
        <ul>
          {purchasedCourses.map((course) => (
            <li key={course.id}>
              <a href={`/courses/${course.id}`}>{course.name}</a>
            </li>
          ))}
        </ul>
      </div>
    </GridContainer>
  );
};

UserGrid.propTypes = {
  userName: PropTypes.string.isRequired,
  purchasedCourses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default UserGrid;
